// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.role-card {
    background: #FFFFFF;
    border: 1px solid #E2E8F0;
    border-radius: 8px;
    padding: 32px;
    text-align: center;
    transition: all 0.2s ease;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    height: 100%;
}

.role-card:hover {
    border-color: #2563eb;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
}

.role-card.primary {
    border: 2px solid #2563eb;
    position: relative;
}

.role-card.primary::before {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
    border-radius: 10px;
    z-index: -1;
    opacity: 0;
    transition: opacity 0.2s ease;
}

.role-card.primary:hover::before {
    opacity: 0.1;
}

.role-icon-wrapper {
    margin-bottom: 20px;
}

.role-icon {
    width: 64px;
    height: 64px;
    background: #F8FAFC;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
}

.role-title {
    font-size: 20px;
    font-weight: 600;
    color: #0F172A;
    margin-bottom: 12px;
}

.role-description {
    font-size: 16px;
    color: #64748B;
    margin-bottom: 24px;
    line-height: 1.5;
    flex-grow: 1;
}

.role-actions {
    display: flex;
    gap: 12px;
    justify-content: center;
}

.role-btn {
    padding: 10px 20px;
    border-radius: 6px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    min-width: 120px;
}

.role-btn.primary {
    background: #2563eb;
    color: #FFFFFF;
    border: 1px solid #2563eb;
}

.role-btn.primary:hover {
    background: #1d4ed8;
    border-color: #1d4ed8;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(37, 99, 235, 0.2);
}

.role-btn.secondary {
    background: #FFFFFF;
    color: #64748B;
    border: 1px solid #CBD5E1;
}

.role-btn.secondary:hover {
    background: #F8FAFC;
    border-color: #94A3B8;
}

@media (max-width: 768px) {
    .role-card {
        padding: 24px;
    }

    .role-actions {
        flex-direction: column;
    }

    .role-btn {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/auth/RoleCard.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,yCAAyC;IACzC,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,0CAA0C;IAC1C,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,6DAA6D;IAC7D,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".role-card {\n    background: #FFFFFF;\n    border: 1px solid #E2E8F0;\n    border-radius: 8px;\n    padding: 32px;\n    text-align: center;\n    transition: all 0.2s ease;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n\n.role-card:hover {\n    border-color: #2563eb;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n    transform: translateY(-2px);\n}\n\n.role-card.primary {\n    border: 2px solid #2563eb;\n    position: relative;\n}\n\n.role-card.primary::before {\n    content: '';\n    position: absolute;\n    top: -2px;\n    left: -2px;\n    right: -2px;\n    bottom: -2px;\n    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n    border-radius: 10px;\n    z-index: -1;\n    opacity: 0;\n    transition: opacity 0.2s ease;\n}\n\n.role-card.primary:hover::before {\n    opacity: 0.1;\n}\n\n.role-icon-wrapper {\n    margin-bottom: 20px;\n}\n\n.role-icon {\n    width: 64px;\n    height: 64px;\n    background: #F8FAFC;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto;\n}\n\n.role-title {\n    font-size: 20px;\n    font-weight: 600;\n    color: #0F172A;\n    margin-bottom: 12px;\n}\n\n.role-description {\n    font-size: 16px;\n    color: #64748B;\n    margin-bottom: 24px;\n    line-height: 1.5;\n    flex-grow: 1;\n}\n\n.role-actions {\n    display: flex;\n    gap: 12px;\n    justify-content: center;\n}\n\n.role-btn {\n    padding: 10px 20px;\n    border-radius: 6px;\n    font-size: 15px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    min-width: 120px;\n}\n\n.role-btn.primary {\n    background: #2563eb;\n    color: #FFFFFF;\n    border: 1px solid #2563eb;\n}\n\n.role-btn.primary:hover {\n    background: #1d4ed8;\n    border-color: #1d4ed8;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(37, 99, 235, 0.2);\n}\n\n.role-btn.secondary {\n    background: #FFFFFF;\n    color: #64748B;\n    border: 1px solid #CBD5E1;\n}\n\n.role-btn.secondary:hover {\n    background: #F8FAFC;\n    border-color: #94A3B8;\n}\n\n@media (max-width: 768px) {\n    .role-card {\n        padding: 24px;\n    }\n\n    .role-actions {\n        flex-direction: column;\n    }\n\n    .role-btn {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
